// extracted by mini-css-extract-plugin
export default {"galleryItem":"c-o_fy","galleryItem_borderTopRadius":"c-o_fz","galleryItem__image":"c-o_fA","galleryItem__image_withBlur":"c-o_fB"};